module.exports = __webpack_public_path__ + "static/media/LK__Refresh.15ff830d.svg";